import { useMemo } from 'react';
import { useGetCompaniesListQuery } from 'store/api/companies';
import { DEFAULT_DATE_FORMAT_PATTERN } from 'utils/dateFormat';

export const useEffectiveDateFormat = (companyId?: number | null): string => {
    const { data: companies } = useGetCompaniesListQuery();

    return useMemo(() => {
        if (!companies || companies.length === 0) return DEFAULT_DATE_FORMAT_PATTERN;
        if (companyId != null) {
            const scoped = companies.find((c) => c.id === companyId);
            if (scoped?.customDateFormat) return scoped.customDateFormat;
        }
        const defaultCompany = companies.find((c) => c.isDefault);
        return defaultCompany?.customDateFormat || DEFAULT_DATE_FORMAT_PATTERN;
    }, [companies, companyId]);
};
